var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-info text-size-5 text-center text-italic"},_vm._l((_vm.achievements),function(achievement){return _c('p',{staticClass:"my"},[_vm._v(_vm._s(achievement))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }